/* EASY GAMES P1.1.4: compatibility entry point; heavy tooltip logic is loaded on demand by cart-disclosure-modal.js. */
window.EasyGamesCartDisclosureLoaderV1?.scan?.();
